"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePicker = void 0;
exports["default"] = APDatePicker;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _pikadayMomentless = require("pikaday-momentless");
var _reduxForm = require("redux-form");
var _reactBemHelper = _interopRequireDefault(require("react-bem-helper"));
var _dateHelper = require("../../../helpers/dateHelper");
var _APIcon = _interopRequireDefault(require("../APIcon"));
var _is_same_day = _interopRequireDefault(require("date-fns/is_same_day"));
var _reactInputMask = _interopRequireDefault(require("react-input-mask"));
var _is_date = _interopRequireDefault(require("date-fns/is_date"));
require("pikaday-momentless/css/pikaday.css");
require("./APDatePicker.css");
var _excluded = ["onChange", "onBlur", "value"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable react/no-is-mounted */
var baseClasses = new _reactBemHelper["default"]({
  name: 'ap-datepicker',
  outputIsString: true
});
var DatePicker = exports.DatePicker = /*#__PURE__*/function (_React$Component) {
  function DatePicker(props) {
    var _this;
    _classCallCheck(this, DatePicker);
    _this = _callSuper(this, DatePicker, [props]);
    _defineProperty(_this, "handleChange", function (value) {
      _this.props.input.onChange(value);
      if (_this.props.customChange) {
        _this.props.customChange(value);
      }
    });
    _this.datepickerRef = null;
    _this.inputMaskRef = null;
    _this._picker = null;
    _this.state = {
      inputMask: '',
      formatMask: ''
    };
    return _this;
  }
  _inherits(DatePicker, _React$Component);
  return _createClass(DatePicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.input.value === undefined) {
        this.inputMaskRef.value = '';
      }
      if (!(0, _is_same_day["default"])(prevProps.input.value, this.props.input.value) && ((0, _is_date["default"])(this.props.input.value) || this.props.input.value === null)) {
        this._picker.setDate(this.props.input.value);
        if (this.props.input.value === null) {
          this.inputMaskRef.value = '';
        } else {
          this.inputMaskRef.value = (0, _dateHelper.formatDate)(this.props.input.value, this.state.formatMask);
        }
      }
      if (((0, _is_date["default"])(this.props.minDate) || this.props.minDate === null) && !(0, _is_same_day["default"])(prevProps.minDate, this.props.minDate)) {
        this._picker.setMinDate(this.props.minDate);
      }
      if (((0, _is_date["default"])(this.props.maxDate) || this.props.maxDate === null) && !(0, _is_same_day["default"])(prevProps.maxDate, this.props.maxDate)) {
        this._picker.setMaxDate(this.props.maxDate);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _createInputDateMask = (0, _dateHelper.createInputDateMask)(),
        inputMask = _createInputDateMask.inputMask,
        formatMask = _createInputDateMask.formatMask;
      this.setState({
        inputMask: inputMask,
        formatMask: formatMask
      });
      var el = this.datepickerRef;
      var _this$props = this.props,
        customFormat = _this$props.customFormat,
        customParse = _this$props.customParse,
        minDate = _this$props.minDate,
        maxDate = _this$props.maxDate;
      this._picker = new _pikadayMomentless.Pikaday(_objectSpread({
        field: el,
        yearRange: [1900, new Date().getFullYear()],
        format: formatMask,
        toString: customFormat,
        parse: customParse,
        minDate: minDate,
        maxDate: maxDate,
        onSelect: this.handleChange
      }, this.props.initialOptions));
      this.addClassNames();
      if ((0, _is_date["default"])(this.props.input.value)) {
        this._picker.setDate(this.props.input.value);
        this.inputMaskRef.value = (0, _dateHelper.formatDate)(this.props.input.value, formatMask);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._picker.destroy();
      this._picker = null;
    }
  }, {
    key: "getCustomClasses",
    value: function getCustomClasses() {
      return new _reactBemHelper["default"]({
        name: this.props.customClass,
        outputIsString: true
      });
    }
  }, {
    key: "addClassNames",
    value: function addClassNames() {
      var _this2 = this;
      var customClasses = this.getCustomClasses();
      this._picker.el.classList.add(baseClasses('calendar'));
      customClasses('calendar').split(' ').forEach(function (customClass) {
        return _this2._picker.el.classList.add(customClass);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        label = _this$props2.label,
        meta = _this$props2.meta,
        info = _this$props2.info,
        input = _this$props2.input,
        disabled = _this$props2.disabled,
        required = _this$props2.required,
        showIcon = _this$props2.showIcon,
        iconClick = _this$props2.iconClick;
      var onChange = input.onChange,
        _onBlur = input.onBlur,
        value = input.value,
        otherInputProps = _objectWithoutProperties(input, _excluded);
      var customClasses = this.getCustomClasses();
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group ".concat(baseClasses('input-wrapper'), " ").concat(customClasses('dpk-wrapper'))
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "ap--label ".concat(baseClasses('label'), " ").concat(customClasses('dpk-label'))
      }, label), /*#__PURE__*/_react["default"].createElement(_reactInputMask["default"], _extends({
        ref: function ref(_ref2) {
          return _this3.inputMaskRef = _ref2;
        },
        mask: this.state.inputMask,
        placeholder: this.state.formatMask,
        disabled: disabled,
        required: required
      }, otherInputProps, {
        onChange: function onChange(e) {
          return _this3.handleChange(e.target.value);
        },
        onBlur: function onBlur(e) {
          return _onBlur((0, _dateHelper.parseDate)(e.target.value));
        }
      }), function (inputProps) {
        return /*#__PURE__*/_react["default"].createElement("input", _extends({
          ref: function ref(_ref) {
            return _this3.datepickerRef = _ref;
          },
          className: "form-control ".concat(baseClasses('input'), " ").concat(customClasses('dpk-input'))
        }, inputProps, {
          autoComplete: "off"
        }));
      }), showIcon && /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('icon-container'),
        onClick: iconClick
      }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "calendar",
        customClass: baseClasses('icon')
      })), /*#__PURE__*/_react["default"].createElement("small", {
        className: "form-text-muted ".concat(baseClasses('info'), "  ").concat(customClasses('dpk-info'))
      }, info), meta.dirty && meta.error && /*#__PURE__*/_react["default"].createElement("span", {
        className: baseClasses('error', 'dpk-error')
      }, meta.error));
    }
  }]);
}(_react["default"].Component);
_defineProperty(DatePicker, "propTypes", {
  input: _propTypes["default"].object.isRequired,
  label: _propTypes["default"].string,
  customClass: _propTypes["default"].string,
  // For custom format visit `toString` section of https://github.com/dbushell/Pikaday#formatting
  customFormat: _propTypes["default"].func,
  customParse: _propTypes["default"].func,
  info: _propTypes["default"].string,
  meta: _propTypes["default"].shape({
    touched: _propTypes["default"].bool,
    error: _propTypes["default"].string
  }),
  disabled: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  initialOptions: _propTypes["default"].object,
  showIcon: _propTypes["default"].bool,
  iconClick: _propTypes["default"].func
});
_defineProperty(DatePicker, "defaultProps", {
  label: 'Date',
  customClass: 'custom-datepicker',
  info: '',
  disabled: false,
  required: false,
  initialOptions: {},
  customFormat: _dateHelper.formatDate,
  customParse: _dateHelper.parseDate,
  showIcon: false
});
function APDatePicker(props) {
  return /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, _extends({
    name: props.name,
    component: DatePicker
  }, props));
}